import { AsyncStateStatus, IPaginator } from '../root.types'

/**
 * Redux Actions Company
 * @typedef InstitutionsTypes
 * @namespace InstitutionsTypes
 * @category React
 * @subcategory Redux / Types
 */

/**
 * Typing constant of action identifiers.
 * </br>
 * The action identifiers are:
 * <pre>
 *     <ul>
 *         <li>@institutions/institutionsRequest</li>
 *         <li>@institutions/describeRequest</li>
 *         <li>@institutions/empsRequest</li>
 *      </ul>
 * </pre>
 * @memberof InstitutionsTypes
 * @function
 * @category React
 * @subcategory Redux / Types
 */
export enum InstitutionsTypes {
    INSTITUTIONS_REQUEST = '@institutions/institutionsRequest',
    DESCRIBE_REQUEST = '@institutions/describeRequest',
    EMPS_REQUEST = '@institutions/empsRequest',
    NOTES_REQUEST = '@institutions/notesRequest',
    ITENS_NOTES_REQUEST = '@institutions/itensNotesRequest',
    BIDDINGS_REQUEST = '@institutions/biddingsRequest',
    CONTRACTS_REQUEST = '@institutions/contractsRequest',
    ADDITIVES_REQUEST = '@institutions/additivesRequest',
    PAYMENTS_REQUEST = '@institutions/paymentsRequest',
    PAYROLLRECORD_REQUEST = '@institutions/payrollrecordRequest',
}

/**
 * @memberof InstitutionsTypes
 * @interface
 * @category React
 * @subcategory Redux / Types
 * @property {string} cnpj Documents data CNPJ.
 * @property {string} city Documents data city.
 * @property {string} org Documents data org.
 * @property {string} state Documents data STATE.
 */
export interface IActionInstitutionsRequest {
    readonly uf?: string
    readonly municipality?: string
    readonly name?: string
    readonly cnpj?: string
}

export interface IActionInstitutionsDescribe {
    readonly cnpj?: string
    readonly recipient_document?: string,
    readonly issuer_document?: string,
    readonly issuer_corporate_name?: string,
    readonly recipient_corporate_name?: string,
    readonly start_date?: string,
    readonly end_date?: string,
    readonly month?: string,
    readonly year?: string,
    readonly paginator?: IPaginator
    readonly access_key?: string
    readonly credor?: string
    readonly limitation?: boolean
    readonly issuer_ip?: string
    readonly port?: string
}

/**
 * @memberof InstitutionsTypes
 * @interface
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 * @property {string} org
 * @property {Array} data
 */
export interface IIstitutionsState {
    readonly status: AsyncStateStatus,
    readonly org: string,
    readonly data: any[]
}

/**
 * @memberof InstitutionsTypes
 * @interface
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 * @property {string} org
 * @property {IIstitutionEmpsDescribe} dataEmps
 * @property {Array} dataServidores
 * @property {Array} notes
 */
export interface IIstitutionsDescribeState {
    readonly status: AsyncStateStatus,
    readonly org: string,
    readonly cnpj: string,
    readonly dataEmps: IIstitutionTabDescribe,
    readonly dataBiddings: IIstitutionTabDescribe,
    readonly dataAdditives: IIstitutionTabDescribe,
    readonly dataPayments: IIstitutionTabDescribe,
    readonly dataContracts: IIstitutionTabDescribe,
    readonly dataPayrollRecords: IIstitutionTabDescribe,
    readonly dataServidores: any[]
    readonly notes: IIstitutionTabDescribe
    readonly itens: IIstitutionTabDescribe
}

export interface IIstitutionTabDescribe {
    readonly status: AsyncStateStatus
    readonly total?: number
    readonly data: any[]
}

/**
 * @memberof CompanyTypes
 * @interface
 * @category React
 * @subcategory Redux / Types
 * @property {IIstitutionsState} request
 * @property {IIstitutionsDescribeState} describe
 */
export interface InstitutionsState {
    request: IIstitutionsState,
    describe: IIstitutionsDescribeState
}
